import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import clsx from "clsx"
import { useFormik } from "formik"
import React, { useState, useCallback, useRef, useEffect } from "react"
import * as R from "ramda";
import { faSquareCheck } from "@fortawesome/free-regular-svg-icons/faSquareCheck";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { DadosTabelaProdutosForaEstoque } from "app/types/produto/ProdutoForaEstoque";

const estiloProdutosForaEstoque = require("./produtosForaEstoque.module.scss").default;
const estilosBotoes = require('../../../estilos/botoes.module.scss').default
const estilosFormulario = require('../../../estilos/formulario.module.scss').default

export type ProdutosForaEstoqueProps = {
    filtrosObterProdutosForaEstoque: FiltrosObterProdutosForaEstoque
    dadosProdutosForaEstoque: PagedMessageResponse<DadosTabelaProdutosForaEstoque>
    onOk: (dadosTabelaProdutosForaEstoque: DadosTabelaProdutosForaEstoque[]) => void
    onPesquisar: (filtrosObterProdutosForaEstoque: FiltrosObterProdutosForaEstoque) => void
    onAlterarListaSelecionada: (filtrosObterProdutosForaEstoque: FiltrosObterProdutosForaEstoque) => void;
    corSelecionado?: string;
    textoSelecionado?: string;
    numeroTotalPaginas: number;
    paginaAtual: number
}

export type FiltrosObterProdutosForaEstoque = {
    Codigo: string
    Descricao: string
    NumeroPagina: number
    Ordem: string
    TamanhoPagina: number
}

export const ProdutosForaEstoque = (props: ProdutosForaEstoqueProps) => {
    const isMounted = useRef(true);
    const [produtosForaEstoqueSelecionados, setProdutosForaEstoquSelecionados] = useState<DadosTabelaProdutosForaEstoque[]>([]);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    const toggleProdutosForaEstoqueSelecionado = useCallback((produtosForaEstoque: DadosTabelaProdutosForaEstoque) => {
        if (!isMounted.current) return;

        setProdutosForaEstoquSelecionados(prev =>
            prev.includes(produtosForaEstoque)
                ? prev.filter(e => e !== produtosForaEstoque)
                : [...prev, produtosForaEstoque]
        );
    }, []);

    const selecionarTodas = useCallback(() => {
        if (!isMounted.current || !props.dadosProdutosForaEstoque?.Entities) return;

        setProdutosForaEstoquSelecionados(prev => {
            const novasSelecoes = props.dadosProdutosForaEstoque?.Entities?.filter(
                value => !prev.includes(value)
            ) ?? [];
            return [...prev, ...novasSelecoes];
        });
    }, [props.dadosProdutosForaEstoque?.Entities]);

    const formik = useFormik({
        initialValues: { ...props.filtrosObterProdutosForaEstoque },
        onSubmit: () => { },
        enableReinitialize: true,
    });

    const handleOk = useCallback(() => {
        props.onOk(produtosForaEstoqueSelecionados);
    }, [produtosForaEstoqueSelecionados, props.onOk]);

    const handlePesquisar = useCallback(() => {
        props.onPesquisar(formik.values);
    }, [formik.values, props.onPesquisar]);

    const handleAlterarListaSelecionada = useCallback((numeroPagina: number) => {
        props.onAlterarListaSelecionada({ ...formik.values, NumeroPagina: numeroPagina });
    }, [formik.values, props.onAlterarListaSelecionada]);

    return (
        <>
            <div className={estiloProdutosForaEstoque.separador} />

            <div className={clsx(estilosFormulario.formulario, estiloProdutosForaEstoque.formProdutosForaEstoque)}>
                <label htmlFor="ProdutosForaEstoque_Codigo">Código</label>
                <input
                    type="text"
                    autoFocus
                    id="ProdutosForaEstoque_Codigo"
                    name="Codigo"
                    value={(formik.values.Codigo) ?? ""}
                    onChange={formik.handleChange}
                />
                <label htmlFor="ProdutosForaEstoque_Descricao">Descrição</label>
                <input
                    type="text"
                    id="ProdutosForaEstoque_Descricao"
                    name="Descricao"
                    value={(formik.values.Descricao) ?? ""}
                    onChange={formik.handleChange}
                />
                <label htmlFor="ProdutosForaEstoque_Ordem">Ordem</label>
                <select
                    id="ProdutosForaEstoque_Ordem"
                    value={(formik.values?.Ordem) ?? ""}
                    name="Ordem"
                    onChange={formik.handleChange}
                >
                    <option value="CODIGO">Código</option>
                    <option value="DESCRICAO">Descrição</option>
                </select>
            </div>

            <button
                className={clsx(estilosBotoes.botaoPrimario, "_mt-3", "_mb-2")}
                type="button"
                id="ProdutosForaEstoque_BotaoPesquisar"
                onClick={handlePesquisar}
            >
                Pesquisar
            </button>

            <div className="_flex _space-x-4">
                <button
                    className={clsx(estilosBotoes.botaoPrimario, "_mt-3", "_mb-2")}
                    type="button"
                    id="ProdutoForaEstoque_BotaoOk1"
                    disabled={produtosForaEstoqueSelecionados.length === 0}
                    onClick={handleOk}
                >
                    Ok
                </button>
                <button
                    className={`${estilosBotoes.botaoIcone} no-global-button`}
                    onClick={selecionarTodas}
                    id="ProdutoForaEstoque_BotaoSelecionarTodos1"
                >
                    <FontAwesomeIcon icon={faSquareCheck} />
                    Selecionar todoss
                </button>
            </div>

            <div className={estiloProdutosForaEstoque.separador} />

            <div>
                <div className={`_table _w-full _border-collapse ${estiloProdutosForaEstoque.tabelaProdutosForaEstoque}`}>
                    <div className="_table-header-group">
                        <div className="_table-row">
                            <div className={`_table-cell ${estiloProdutosForaEstoque.tableCellHeader}`}>
                                Código
                            </div>
                            <div className={`_table-cell ${estiloProdutosForaEstoque.tableCellHeader}`}>
                                Descrição
                            </div>
                        </div>
                    </div>
                    <div className="_table-row-group">
                        {props.dadosProdutosForaEstoque?.Entities?.map((produto, index) => (
                            <div
                                key={`TabelaProdForaEstoque_${index}`}
                                id={`TabelaProdForaEstoque_${index}`}
                                className={`_table-row ${produtosForaEstoqueSelecionados.includes(produto)
                                    ? estiloProdutosForaEstoque.linhaSelecionada
                                    : estiloProdutosForaEstoque.linha
                                    }`}
                                style={
                                    produtosForaEstoqueSelecionados.includes(produto)
                                        ? {
                                            backgroundColor: props.corSelecionado,
                                            color: props.textoSelecionado,
                                        }
                                        : {}
                                }
                                onClick={() => toggleProdutosForaEstoqueSelecionado(produto)}
                            >
                                <div className={`_table-cell ${estiloProdutosForaEstoque.tableCellBody}`}
                                    key={`TabelaProdForaEstoque_Codigo_${index}`}
                                    id={`TabelaProdForaEstoque_Codigo_${index}`}
                                >
                                    {produto.Codigo}
                                </div>
                                <div className={`_table-cell ${estiloProdutosForaEstoque.tableCellBody}`}
                                    key={`TabelaProdForaEstoque_Descricao_${index}`}
                                    id={`TabelaProdForaEstoque_Descricao_${index}`}
                                >
                                    {produto.Descricao}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <br />

            {props.numeroTotalPaginas > 1 &&
                <Paginacao
                    paginaAtual={props.paginaAtual}
                    totalPaginas={props.numeroTotalPaginas}
                    id="ProdutosForaEstoque_Paginacao"
                    onAlterarListaSelecionada={handleAlterarListaSelecionada}
                />
            }

            <div className="_flex _space-x-4">
                <button
                    className={clsx(estilosBotoes.botaoPrimario, "_mt-3", "_mb-2")}
                    type="button"
                    id="ProdutoForaEstoque_BotaoOk2"
                    disabled={produtosForaEstoqueSelecionados.length === 0}
                    onClick={handleOk}
                >
                    Ok
                </button>
                <button
                    className={`${estilosBotoes.botaoIcone} no-global-button`}
                    onClick={selecionarTodas}
                    id="ProdutoForaEstoque_BotaoSelecionarTodos2"
                >
                    <FontAwesomeIcon icon={faSquareCheck} />
                    Selecionar todos
                </button>
            </div>
            {<section style={{ marginBottom: "100px" }} />}
        </>
    )
}